<template>
  <v-card class="d-flex flex-column asessment-card">
    <header-assessment
      :data="headerData"
      pl="2vw"
      pr="2vw"
      title="Assesmen Fisioterapi"
    />
    <v-divider></v-divider>
    <div class="content-wrapper">
      <v-row v-if="!isLoading" no-gutters class="fill-height">
        <v-col class="form-container flex-grow-1" style="flex: 1">
          <input-assessment
            ref="assessment"
            :is-emr="isEmr"
            v-if="!emrData"
            :emr-data="emrData"
            @close-form="$emit('close-form')"
            :patient-data="patientData"
            @refresh-history="handleRefreshHistory"
          />
          <input-assessment
            v-else
            ref="assessment"
            @refresh-history="handleRefreshHistory"
            @close-form="$emit('close-form')"
            :patient-data="patientData"
            :is-emr="isEmr"
            :emr-data="emrData"
          />
        </v-col>
        <v-col class="sidebar-container" style="flex: 0.4">
          <!-- v-if="!isEmr" -->
          <history-sidebar
            @navigate-to="navigateTo"
            :is-general="true"
            :header-data="headerData"
            ref="history"
            unit="Poli Fisioterapi"
          />
        </v-col>
      </v-row>
    </div>
  </v-card>
</template>

<script>
import HistorySidebar from '../AssessmentComponents/HistorySidebarV2.vue';
import HeaderAssessment from '../AssessmentComponents/HeaderAssessment.vue';
import InputAssessment from './InputAssestment.vue';
import formatMixin from '@/mixin/formatMixin';
const moment = require('moment');

export default {
  name: 'GeneralAssessment',
  mixins: [formatMixin],
  components: {
    HistorySidebar,
    HeaderAssessment,
    InputAssessment,
  },
  data() {
    return {
      headerData: '',
    };
  },
  props: {
    patientData: Object,
    isEmr: Boolean,
    emrData: {
      type: Object,
      default: null,
    },
  },
  methods: {
    navigateTo(ref) {
      const el = this.$refs.assessment.$refs[ref];
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
      }
    },
    handleRefreshHistory() {
      this.$refs.history.showAllHistories();
    },
  },
  mounted() {
    this.headerData = [
      {
        label: 'No.RM',
        text: this.patientData.rmNumber,
      },
      {
        label: 'Nama',
        text: `${this.patientData.meta.name} (${
          this.patientData.meta.gender === 'Laki-laki' ? 'L' : 'P'
        })`,
      },
      {
        label: 'Tanggal Lahir',
        text: `${moment(this.patientData.meta.birthDate, 'DD MMMM YYYY').format(
          'DD/MM/YYYY',
        )} (${this.ageDuration(
          moment(this.patientData.meta.birthDate, 'DD MMMM YYYY'),
        )})`,
      },
      {
        label: 'Hambatan dalam Berkomunikasi',
        text: this.patientData.commmunicationObstacles || 'Tidak Ada',
      },
    ];
  },
};
</script>

<style lang="scss" scoped>
.asessment-card {
  height: 90vh;
  max-height: 700px;
  width: 1200px;
  max-width: 95vw;
}

.content-wrapper {
  flex-grow: 1;
  overflow: hidden;
  height: 100%;
}

.form-container {
  height: 100%;
}

.sidebar-container {
  height: 100%;
}
</style>
